import React from 'react';

// `keywords` feed the sidebar search only — terms a reader might type that aren't in the label.
export const docsSections: { path: string; label: string; keywords?: string }[] = [
  { path: '', label: 'What is MFlow?', keywords: 'overview intro introduction' },
  { path: 'sign-in', label: 'Sign In', keywords: 'login account google' },
  { path: 'dashboard', label: 'Dashboard Overview', keywords: 'kpi metrics studio' },
  { path: 'psi', label: 'PSI Score', keywords: 'project stability index health' },
  { path: 'platforms', label: 'Jira, Trello & Standalone', keywords: 'providers comparison' },
  {
    path: 'standalone',
    label: 'Standalone Projects',
    keywords: 'kanban board subtasks sharing invite invitation members owner collaboration columns agent role',
  },
  { path: 'connect-jira', label: 'Connect Jira', keywords: 'oauth sync' },
  { path: 'connect-trello', label: 'Connect Trello', keywords: 'oauth' },
  { path: 'connect-slack', label: 'Connect Slack', keywords: 'notifications' },
  { path: 'connect-telegram', label: 'Connect Telegram', keywords: 'notifications' },
  { path: 'connect-email', label: 'Connect Email', keywords: 'notifications' },
  {
    path: 'settings',
    label: 'Settings',
    keywords: 'notifications digest priority default provider automation drift reviewer delete account',
  },
  {
    path: 'ai-providers',
    label: 'AI Providers & Keys',
    keywords: 'byok api key openai anthropic claude gemini deepseek model default provider',
  },
  { path: 'wizard', label: 'Spec-to-Project Wizard', keywords: 'spec generate' },
  { path: 'transfer', label: 'Project Transfer', keywords: 'migrate copy' },
  {
    path: 'coding-agent',
    label: 'Coding Agent',
    keywords: 'sandbox tier queue github pull request pr review resume board status working byok',
  },
  { path: 'git-reviewer', label: 'Git Reviewer', keywords: 'pull request pr code review github verdict approve adr' },
  {
    path: 'knowledge-base',
    label: 'Knowledge Base & ADRs',
    keywords: 'adr architecture decision drift docs guide convention',
  },
  { path: 'ai-chat', label: 'AI Assistant', keywords: 'agent chat' },
  { path: 'chat', label: 'Chat Sessions & Context', keywords: 'session history' },
  { path: 'mcp', label: 'MCP Server', keywords: 'claude desktop claude code integration' },
  { path: 'ai-chat/tools', label: 'Agent Tool Reference', keywords: 'tools capabilities' },
  { path: 'faq', label: 'FAQ', keywords: 'questions help' },
];

export const Step: React.FC<{ n: number; children: React.ReactNode }> = ({ n, children }) => (
  <div className="flex gap-4 items-start">
    <div className="shrink-0 w-7 h-7 rounded-full bg-primary text-primary-content text-sm font-bold flex items-center justify-center mt-0.5">
      {n}
    </div>
    <div className="text-base-content/80 text-sm leading-relaxed pt-0.5">{children}</div>
  </div>
);

export const Callout: React.FC<{ type?: 'info' | 'warning' | 'tip'; children: React.ReactNode }> = ({
  type = 'info',
  children,
}) => {
  const styles = {
    info: 'bg-info/10 border-info/40',
    warning: 'bg-warning/10 border-warning/40',
    tip: 'bg-success/10 border-success/40',
  };
  const icons = { info: 'ℹ️', warning: '⚠️', tip: '💡' };
  return (
    <div className={`border rounded-lg px-4 py-3 text-sm leading-relaxed ${styles[type]}`}>
      <span className="mr-2">{icons[type]}</span>
      {children}
    </div>
  );
};

export const Badge: React.FC<{ children: React.ReactNode; color?: string }> = ({ children, color = 'badge-ghost' }) => (
  <span className={`badge badge-sm ${color} font-mono`}>{children}</span>
);
